/**
 * Feature Toggle Keys Enum
 * All CPM feature toggle keys used across the application
 */
export const FEATURE_TOGGLE_KEYS = {
  CPM_SEARCH_FEATURE: 'cpm-search-feature',
  CPM_ADMIN_LENDER_REQUEST: 'cpm-admin-lender-request',
  CPM_LENDER_ADD_EDIT_PROJECT: 'cpm-lender-add-edit-project',
  CPM_REQUEST_GRID_INTERNAL: 'cpm-request-grid-internal',
  CPM_LENDER_ADD_EDIT_PHASE: 'cpm-lender-add-edit-phase',
  CPM_REQUEST_GRID_EXTERNAL: 'cpm-request-grid-external',
  CPM_STATUS_REVIEW_REQUEST: 'cpm-status-review-request',
  CPM_MAX_FILE_UPLOAD_SIZE: 'cpm-max-file-upload-size',
  CPM_DUPLICATE_REQUEST_CHECK: 'cpm-duplicate-request-check'
};

// For backward compatibility and easier usage
export const {
  CPM_SEARCH_FEATURE,
  CPM_ADMIN_LENDER_REQUEST,
  CPM_LENDER_ADD_EDIT_PROJECT,
  CPM_REQUEST_GRID_INTERNAL,
  CPM_LENDER_ADD_EDIT_PHASE,
  CPM_REQUEST_GRID_EXTERNAL,
  CPM_STATUS_REVIEW_REQUEST,
  CPM_MAX_FILE_UPLOAD_SIZE,
  CPM_DUPLICATE_REQUEST_CHECK
} = FEATURE_TOGGLE_KEYS;
